/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'settings': {
    width: 16,
    height: 16,
    viewBox: '0 0 47 47',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M26.51 46.5h-5.18l-2.51-6.19a15.14 15.14 0 0 1-3.35-1.51l-5.94 2.43-3.68-3.68 2.43-5.94a16 16 0 0 1-1.59-3.43L.5 25.67v-5.18L6.69 18a15.14 15.14 0 0 1 1.51-3.35L5.77 8.7 9.45 5l5.94 2.43a15.06 15.06 0 0 1 3.43-1.17L21.33.5h5.19L29 6.27a19.79 19.79 0 0 1 3.35 1.25L38.3 5 42 8.7l-2.43 5.94A15.89 15.89 0 0 1 40.73 18l5.77 2.51v5.19l-5.77 2.51a19.79 19.79 0 0 1-1.25 3.35L42 37.47l-3.7 3.68-5.94-2.43A17.47 17.47 0 0 1 29 40.31zm.14-16.59a10.59 10.59 0 0 1-1.33.4 10.54 10.54 0 0 1-1.41.13 7.52 7.52 0 0 1-5.69-2.68 7.31 7.31 0 0 1-1.59-6.11 7.22 7.22 0 0 1 5.77-5.77 7.52 7.52 0 0 1 7.11 2.51 7.31 7.31 0 0 1 1.59 6.11" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/settings.js